import Link from 'next/link'

interface UsageBadgeProps {
  percentage: number
}

export function UsageBadge({ percentage }: UsageBadgeProps) {
  const dotColor = percentage >= 80
    ? 'var(--color-error)'
    : percentage >= 60
      ? 'var(--color-warning)'
      : 'var(--color-success)'

  return (
    <Link
      href="/settings/billing"
      className="flex items-center gap-1.5 rounded-full border border-[var(--color-border)] px-2.5 py-1 text-xs text-[var(--color-text-muted)] hover:bg-[var(--color-bg-elevated)]"
      title={`${percentage}% of plan usage`}
    >
      <span
        className="inline-block h-2 w-2 rounded-full"
        style={{ backgroundColor: dotColor }}
      />
      <span>{percentage}%</span>
    </Link>
  )
}
